import {useCallback, useRef} from "react";

export default function useDebounce(delay: number) {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const debouncedCb = useCallback(
    (cb: () => void) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => cb(), delay);
    },
    [delay],
  );

  return debouncedCb;
}
